// //export const resList =[
//     {
//         "info": {
//           "id": "410259",
//           "name": "KFC",
//           "cloudinaryImageId": "f01666ac73626461d7455d9c24005cd4",
//           "locality": "Saidabad",
//           "areaName": "Champapet",
//           "costForTwo": "₹450 for two",
//           "cuisines": [
//             "Burgers",
//             "Biryani",
//             "American",
//             "Snacks",
//             "Fast Food"
//           ],
//           "avgRating": 4.1,
//           "parentId": "547",
//           "avgRatingString": "4.1",
//           "totalRatingsString": "5K+",
//           "sla": {
//             "deliveryTime": 26,
//             "lastMileTravel": 1.7,
//             "serviceability": "SERVICEABLE",
//             "slaString": "25-30 mins",
//             "lastMileTravelString": "1.7 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:00:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "ITEMS",
//             "subHeader": "AT ₹179"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/kfc-saidabad-champapet-hyderabad-410259",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "23694",
//           "name": "McDonald's",
//           "cloudinaryImageId": "03501c33ecb3a3105124441e541e6fe4",
//           "locality": "Appaji",
//           "areaName": "Dilsukhnagar",
//           "costForTwo": "₹400 for two",
//           "cuisines": [
//             "Burgers",
//             "Beverages",
//             "Cafe",
//             "Desserts"
//           ],
//           "avgRating": 4.4,
//           "parentId": "630",
//           "avgRatingString": "4.4",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 29,
//             "lastMileTravel": 3.7,
//             "serviceability": "SERVICEABLE",
//             "slaString": "25-30 mins",
//             "lastMileTravelString": "3.7 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-16 00:45:00",
//             "opened": true
//           },
//           "badges": {
//             "textExtendedBadges": [
//               {
//                 "iconId": "guiltfree/GF_Logo_android_3x",
//                 "shortDescription": "options available",
//                 "fontColor": "#7E808C"
//               }
//             ]
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "",
//                       "fontColor": "#7E808C",
//                       "iconId": "guiltfree/GF_Logo_android_3x",
//                       "shortDescription": "options available"
//                     }
//                   }
//                 ]
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "ITEMS",
//             "subHeader": "AT ₹199"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/mcdonalds-appaji-dilsukhnagar-hyderabad-23694",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "28772",
//           "name": "Domino's Pizza",
//           "cloudinaryImageId": "niennvouyi6dnovovhzh",
//           "locality": "Santoshnagar & Saidabad",
//           "areaName": "Santosh Nagar",
//           "costForTwo": "₹400 for two",
//           "cuisines": [
//             "Pizzas",
//             "Italian",
//             "Pastas",
//             "Desserts"
//           ],
//           "avgRating": 4.4,
//           "parentId": "2456",
//           "avgRatingString": "4.4",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 25,
//             "serviceability": "SERVICEABLE",
//             "slaString": "25 mins",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-16 02:59:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "20% OFF",
//             "subHeader": "UPTO ₹50"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/dominos-pizza-santoshnagar-and-saidabad-santosh-nagar-hyderabad-28772",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "73457",
//           "name": "Subway",
//           "cloudinaryImageId": "63178e3e64d503a479f2a2048a474552",
//           "locality": "DMRI X road",
//           "areaName": "Kanchan Bagh",
//           "costForTwo": "₹350 for two",
//           "cuisines": [
//             "Salads",
//             "Snacks",
//             "Desserts",
//             "Beverages"
//           ],
//           "avgRating": 4.1,
//           "parentId": "2",
//           "avgRatingString": "4.1",
//           "totalRatingsString": "1K+",
//           "sla": {
//             "deliveryTime": 38,
//             "lastMileTravel": 1.8,
//             "serviceability": "SERVICEABLE",
//             "slaString": "35-40 mins",
//             "lastMileTravelString": "1.8 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 19:40:00",
//             "opened": true
//           },
//           "badges": {
//             "textExtendedBadges": [
//               {
//                 "iconId": "guiltfree/GF_Logo_android_3x",
//                 "shortDescription": "options available",
//                 "fontColor": "#7E808C"
//               }
//             ]
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "",
//                       "fontColor": "#7E808C",
//                       "iconId": "guiltfree/GF_Logo_android_3x",
//                       "shortDescription": "options available"
//                     }
//                   }
//                 ]
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
            
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/subway-dmri-x-road-kanchan-bagh-hyderabad-73457",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "109168",
//           "name": "Al Rabea Al Arabi Cafeteria",
//           "cloudinaryImageId": "lu7b9y7xps4icwn6xzfj",
//           "locality": "Opposite Lucky Hotel",
//           "areaName": "Santoshnagar & Saidabad",
//           "costForTwo": "₹250 for two",
//           "cuisines": [
//             "Lebanese",
//             "Arabian"
//           ],
//           "avgRating": 4.5,
//           "parentId": "7582",
//           "avgRatingString": "4.5",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 24,
//             "lastMileTravel": 1.3,
//             "serviceability": "SERVICEABLE",
//             "slaString": "20-25 mins",
//             "lastMileTravelString": "1.3 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-16 00:30:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "10% OFF",
//             "subHeader": "UPTO ₹40"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/al-rabea-al-arabi-cafeteria-opposite-lucky-hotel-santoshnagar-and-saidabad-hyderabad-109168",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "136301",
//           "name": "KS Bakers",
//           "cloudinaryImageId": "6127cb288329ad1c9e988276914d48ad",
//           "locality": "Near Ikon Hospital",
//           "areaName": "Kothapet & Dilsukhnagar",
//           "costForTwo": "₹200 for two",
//           "cuisines": [
//             "Bakery",
//             "Pizzas",
//             "Desserts",
//             "Snacks",
//             "Fast Food"
//           ],
//           "avgRating": 4.1,
//           "parentId": "574",
//           "avgRatingString": "4.1",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 29,
//             "lastMileTravel": 2.9,
//             "serviceability": "SERVICEABLE",
//             "slaString": "25-30 mins",
//             "lastMileTravelString": "2.9 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 22:45:00",
//             "opened": true
//           },
//           "badges": {
//             "textExtendedBadges": [
//               {
//                 "iconId": "guiltfree/GF_Logo_android_3x",
//                 "shortDescription": "options available",
//                 "fontColor": "#7E808C"
//               }
//             ]
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "",
//                       "fontColor": "#7E808C",
//                       "iconId": "guiltfree/GF_Logo_android_3x",
//                       "shortDescription": "options available"
//                     }
//                   }
//                 ]
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "₹50 OFF",
//             "subHeader": "ABOVE ₹249",
//             "discountTag": "FLAT DEAL"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/ks-bakers-near-ikon-hospital-kothapet-and-dilsukhnagar-hyderabad-136301",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "140117",
//           "name": "Imperial Multi-Cusine Restaurant",
//           "cloudinaryImageId": "ib97mlmkhuwwv51syyca",
//           "locality": "Saroor Nagar West",
//           "areaName": "Saroor Nagar West",
//           "costForTwo": "₹400 for two",
//           "cuisines": [
//             "Biryani",
//             "Chinese",
//             "Indian",
//             "Kebabs",
//             "Tandoor"
//           ],
//           "avgRating": 4.3,
//           "parentId": "19254",
//           "avgRatingString": "4.3",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 28,
//             "lastMileTravel": 1.9,
//             "serviceability": "SERVICEABLE",
//             "slaString": "25-30 mins",
//             "lastMileTravelString": "1.9 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:59:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "₹100 OFF",
//             "subHeader": "ABOVE ₹179",
//             "discountTag": "FLAT DEAL"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/imperial-multi-cusine-restaurant-saroor-nagar-west-hyderabad-140117",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "124595",
//           "name": "Sweet Truth - Cake and Desserts",
//           "cloudinaryImageId": "78408969d316991befba0a6eca303e1c",
//           "locality": "Moosarambagh",
//           "areaName": "New Malakpet",
//           "costForTwo": "₹450 for two",
//           "cuisines": [
//             "Snacks",
//             "Bakery",
//             "Desserts",
//             "Beverages"
//           ],
//           "avgRating": 4.4,
//           "parentId": "4444",
//           "avgRatingString": "4.4",
//           "totalRatingsString": "1K+",
//           "sla": {
//             "deliveryTime": 28,
//             "lastMileTravel": 2.6,
//             "serviceability": "SERVICEABLE",
//             "slaString": "25-30 mins",
//             "lastMileTravelString": "2.6 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:59:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "60% OFF",
//             "subHeader": "UPTO ₹110",
//             "discountCalloutInfo": {
//               "message": "Free Delivery",
//               "logoCtx": {
//                 "logo": "v1655895371/free_delivery_logo_hqipbo.png"
//               }
//             }
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/sweet-truth-cake-and-desserts-moosarambagh-new-malakpet-hyderabad-124595",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "124586",
//           "name": "Faasos - Wraps, Rolls & Shawarma",
//           "cloudinaryImageId": "af33b81798b11deba338e94b7585d348",
//           "locality": "Moosarambagh",
//           "areaName": "New Malakpet",
//           "costForTwo": "₹200 for two",
//           "cuisines": [
//             "Kebabs",
//             "Fast Food",
//             "Snacks",
//             "American",
//             "Healthy Food",
//             "Desserts",
//             "Beverages"
//           ],
//           "avgRating": 4,
//           "parentId": "21809",
//           "avgRatingString": "4.0",
//           "totalRatingsString": "5K+",
//           "sla": {
//             "deliveryTime": 32,
//             "lastMileTravel": 2.6,
//             "serviceability": "SERVICEABLE",
//             "slaString": "30-35 mins",
//             "lastMileTravelString": "2.6 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:59:00",
//             "opened": true
//           },
//           "badges": {
//             "textExtendedBadges": [
//               {
//                 "iconId": "guiltfree/GF_Logo_android_3x",
//                 "shortDescription": "options available",
//                 "fontColor": "#7E808C"
//               }
//             ]
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "",
//                       "fontColor": "#7E808C",
//                       "iconId": "guiltfree/GF_Logo_android_3x",
//                       "shortDescription": "options available"
//                     }
//                   }
//                 ]
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "ITEMS",
//             "subHeader": "AT ₹129",
//             "discountCalloutInfo": {
//               "message": "Free Delivery",
//               "logoCtx": {
//                 "logo": "v1655895371/free_delivery_logo_hqipbo.png"
//               }
//             }
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/faasos-wraps-rolls-and-shawarma-moosarambagh-new-malakpet-hyderabad-124586",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "57903",
//           "name": "Capital Multi Cuisine Restaurant",
//           "cloudinaryImageId": "ijy2jxi7lfwsebdtazpi",
//           "locality": "Malakpet",
//           "areaName": "Malakpet",
//           "costForTwo": "₹500 for two",
//           "cuisines": [
//             "Biryani",
//             "Arabian",
//             "Lebanese"
//           ],
//           "avgRating": 4,
//           "parentId": "19262",
//           "avgRatingString": "4.0",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 28,
//             "lastMileTravel": 2.5,
//             "serviceability": "SERVICEABLE",
//             "slaString": "25-30 mins",
//             "lastMileTravelString": "2.5 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:59:00",
//             "opened": true
//           },
//           "badges": {
//             "textExtendedBadges": [
//               {
//                 "iconId": "guiltfree/GF_Logo_android_3x",
//                 "shortDescription": "options available",
//                 "fontColor": "#7E808C"
//               }
//             ]
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "",
//                       "fontColor": "#7E808C",
//                       "iconId": "guiltfree/GF_Logo_android_3x",
//                       "shortDescription": "options available"
//                     }
//                   }
//                 ]
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "40% OFF",
//             "subHeader": "UPTO ₹80"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/capital-multi-cuisine-restaurant-malakpet-hyderabad-57903",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "63894",
//           "name": "Kinara Grand",
//           "cloudinaryImageId": "fe8291a4d9ac30500ed2898121bbe623",
//           "locality": "Manda Malamma Garden Road",
//           "areaName": "Srinivasa Gayatri Nagar",
//           "costForTwo": "₹500 for two",
//           "cuisines": [
//             "Biryani",
//             "North Indian",
//             "Chinese"
//           ],
//           "avgRating": 4.1,
//           "parentId": "8469",
//           "avgRatingString": "4.1",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 29,
//             "lastMileTravel": 2.7,
//             "serviceability": "SERVICEABLE",
//             "slaString": "25-30 mins",
//             "lastMileTravelString": "2.7 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:00:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "₹125 OFF",
//             "subHeader": "ABOVE ₹199",
//             "discountTag": "FLAT DEAL"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/kinara-grand-manda-malamma-garden-road-srinivasa-gayatri-nagar-hyderabad-63894",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "260575",
//           "name": "Istah - The Mediterranean Way",
//           "cloudinaryImageId": "9a01f2935fcb5ae05426db8264062102",
//           "locality": "Vijetha Golden Empire",
//           "areaName": "Kothapet & Dilsukhnagar",
//           "costForTwo": "₹250 for two",
//           "cuisines": [
//             "Mediterranean",
//             "Snacks",
//             "Biryani",
//             "Grill",
//             "Kebabs",
//             "Arabian",
//             "Lebanese",
//             "Beverages",
//             "Desserts",
//             "Italian",
//             "Turkish"
//           ],
//           "avgRating": 4.2,
//           "parentId": "3518",
//           "avgRatingString": "4.2",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 36,
//             "lastMileTravel": 3,
//             "serviceability": "SERVICEABLE",
//             "slaString": "35-40 mins",
//             "lastMileTravelString": "3.0 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:00:00",
//             "opened": true
//           },
//           "badges": {
//             "imageBadges": [
//               {
//                 "imageId": "v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png",
//                 "description": "OnlyOnSwiggy"
//               }
//             ],
//             "textExtendedBadges": [
//               {
//                 "iconId": "guiltfree/GF_Logo_android_3x",
//                 "shortDescription": "options available",
//                 "fontColor": "#7E808C"
//               }
//             ]
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "OnlyOnSwiggy",
//                       "imageId": "v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png"
//                     }
//                   }
//                 ]
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "",
//                       "fontColor": "#7E808C",
//                       "iconId": "guiltfree/GF_Logo_android_3x",
//                       "shortDescription": "options available"
//                     }
//                   }
//                 ]
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "60% OFF",
//             "subHeader": "UPTO ₹110"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/istah-the-mediterranean-way-vijetha-golden-empire-kothapet-and-dilsukhnagar-hyderabad-260575",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "40377",
//           "name": "Lucky Restaurant",
//           "cloudinaryImageId": "uvapcfajlsbctskdhuhl",
//           "locality": "Santosh Nagar",
//           "areaName": "Santosh Nagar",
//           "costForTwo": "₹300 for two",
//           "cuisines": [
//             "Biryani",
//             "Tandoor"
//           ],
//           "avgRating": 4.1,
//           "parentId": "293683",
//           "avgRatingString": "4.1",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 24,
//             "lastMileTravel": 1.6,
//             "serviceability": "SERVICEABLE",
//             "slaString": "20-25 mins",
//             "lastMileTravelString": "1.6 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-16 01:30:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "₹100 OFF",
//             "subHeader": "ABOVE ₹179",
//             "discountTag": "FLAT DEAL"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/lucky-restaurant-santosh-nagar-hyderabad-40377",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "60071",
//           "name": "Karachi Bakery",
//           "cloudinaryImageId": "c3e7f82d0868ad673e6b54ed876e1091",
//           "locality": "Saleem Nagar",
//           "areaName": "Kothapet & Dilsukhnagar",
//           "costForTwo": "₹400 for two",
//           "cuisines": [
//             "Bakery",
//             "Pizzas",
//             "Chinese",
//             "Italian",
//             "American",
//             "Sweets",
//             "Desserts",
//             "Beverages"
//           ],
//           "avgRating": 4.3,
//           "parentId": "1262",
//           "avgRatingString": "4.3",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 32,
//             "lastMileTravel": 2.9,
//             "serviceability": "SERVICEABLE",
//             "slaString": "30-35 mins",
//             "lastMileTravelString": "2.9 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-16 01:00:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "20% OFF",
//             "subHeader": "UPTO ₹50"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/karachi-bakery-saleem-nagar-kothapet-and-dilsukhnagar-hyderabad-60071",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "156177",
//           "name": "The Good Bowl",
//           "cloudinaryImageId": "6e04be27387483a7c00444f8e8241108",
//           "locality": "Dilsukhnagar FC",
//           "areaName": "New Malakpet",
//           "costForTwo": "₹400 for two",
//           "cuisines": [
//             "Biryani",
//             "North Indian",
//             "Pastas",
//             "Punjabi",
//             "Desserts",
//             "Beverages"
//           ],
//           "avgRating": 4.2,
//           "parentId": "7918",
//           "avgRatingString": "4.2",
//           "totalRatingsString": "1K+",
//           "sla": {
//             "deliveryTime": 32,
//             "lastMileTravel": 2.6,
//             "serviceability": "SERVICEABLE",
//             "slaString": "30-35 mins",
//             "lastMileTravelString": "2.6 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:59:00",
//             "opened": true
//           },
//           "badges": {
//             "textExtendedBadges": [
//               {
//                 "iconId": "guiltfree/GF_Logo_android_3x",
//                 "shortDescription": "options available",
//                 "fontColor": "#7E808C"
//               }
//             ]
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "",
//                       "fontColor": "#7E808C",
//                       "iconId": "guiltfree/GF_Logo_android_3x",
//                       "shortDescription": "options available"
//                     }
//                   }
//                 ]
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "60% OFF",
//             "subHeader": "UPTO ₹110",
//             "discountCalloutInfo": {
//               "message": "Free Delivery",
//               "logoCtx": {
//                 "logo": "v1655895371/free_delivery_logo_hqipbo.png"
//               }
//             }
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/the-good-bowl-dilsukhnagar-fc-new-malakpet-hyderabad-156177",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "244883",
//           "name": "NIC Ice Creams",
//           "cloudinaryImageId": "85825a6d74b1059a63a9b688de9f67ce",
//           "locality": "Magic Spoons Enterprises",
//           "areaName": "Kothapet",
//           "costForTwo": "₹120 for two",
//           "cuisines": [
//             "Ice Cream",
//             "Desserts"
//           ],
//           "avgRating": 4.6,
//           "veg": true,
//           "parentId": "6249",
//           "avgRatingString": "4.6",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 33,
//             "lastMileTravel": 5,
//             "serviceability": "SERVICEABLE",
//             "slaString": "30-35 mins",
//             "lastMileTravelString": "5.0 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-16 00:00:00",
//             "opened": true
//           },
//           "badges": {
//             "textExtendedBadges": [
//               {
//                 "iconId": "guiltfree/GF_Logo_android_3x",
//                 "shortDescription": "brand",
//                 "fontColor": "#7E808C"
//               }
//             ]
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "",
//                       "fontColor": "#7E808C",
//                       "iconId": "guiltfree/GF_Logo_android_3x",
//                       "shortDescription": "brand"
//                     }
//                   }
//                 ]
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "ITEMS",
//             "subHeader": "AT ₹169"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/nic-ice-creams-magic-spoons-enterprises-kothapet-hyderabad-244883",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "48778",
//           "name": "The Thick Shake Factory",
//           "cloudinaryImageId": "se2snqittbnngjfdihx9",
//           "locality": "Dilsukh Nagar",
//           "areaName": "Dilsukh Nagar",
//           "costForTwo": "₹200 for two",
//           "cuisines": [
//             "Beverages"
//           ],
//           "avgRating": 4.2,
//           "parentId": "1033",
//           "avgRatingString": "4.2",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 28,
//             "lastMileTravel": 2.6,
//             "serviceability": "SERVICEABLE",
//             "slaString": "25-30 mins",
//             "lastMileTravelString": "2.6 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:00:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "10% OFF",
//             "subHeader": "UPTO ₹40"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/the-thick-shake-factory-dilsukh-nagar-hyderabad-48778",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "18005",
//           "name": "Cafe Coffee Day",
//           "cloudinaryImageId": "b70c7d23d197251b7b315b7e4d8173ae",
//           "locality": "Marthacharya Complex",
//           "areaName": "Moosarambagh",
//           "costForTwo": "₹400 for two",
//           "cuisines": [
//             "Beverages",
//             "Cafe",
//             "Snacks",
//             "Desserts",
//             "Burgers",
//             "Ice Cream",
//             "Bakery",
//             "Fast Food"
//           ],
//           "avgRating": 4.2,
//           "parentId": "1",
//           "avgRatingString": "4.2",
//           "totalRatingsString": "5K+",
//           "sla": {
//             "deliveryTime": 31,
//             "lastMileTravel": 2.6,
//             "serviceability": "SERVICEABLE",
//             "slaString": "30-35 mins",
//             "lastMileTravelString": "2.6 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 22:45:00",
//             "opened": true
//           },
//           "badges": {
//             "textExtendedBadges": [
//               {
//                 "iconId": "guiltfree/GF_Logo_android_3x",
//                 "shortDescription": "options available",
//                 "fontColor": "#7E808C"
//               }
//             ]
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
//                 "badgeObject": [
//                   {
//                     "attributes": {
//                       "description": "",
//                       "fontColor": "#7E808C",
//                       "iconId": "guiltfree/GF_Logo_android_3x",
//                       "shortDescription": "options available"
//                     }
//                   }
//                 ]
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "40% OFF",
//             "subHeader": "UPTO ₹100"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/cafe-coffee-day-marthacharya-complex-moosarambagh-hyderabad-18005",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "237003",
//           "name": "Burger King",
//           "cloudinaryImageId": "e33e1d3ba7d6b2bb0d45e1001b731fcf",
//           "locality": "Metro Rail Mall multiplex",
//           "areaName": "New Malakpet",
//           "costForTwo": "₹350 for two",
//           "cuisines": [
//             "Burgers",
//             "American"
//           ],
//           "avgRating": 4.2,
//           "parentId": "166",
//           "avgRatingString": "4.2",
//           "totalRatingsString": "10K+",
//           "sla": {
//             "deliveryTime": 39,
//             "lastMileTravel": 2.9,
//             "serviceability": "SERVICEABLE",
//             "slaString": "35-40 mins",
//             "lastMileTravelString": "2.9 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-16 03:00:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "60% OFF",
//             "subHeader": "UPTO ₹120"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/burger-king-metro-rail-mall-multiplex-new-malakpet-hyderabad-237003",
//           "type": "WEBLINK"
//         }
//       },
//       {
//         "info": {
//           "id": "124590",
//           "name": "Oven Story Pizza - Standout Toppings",
//           "cloudinaryImageId": "b39e4312ae2e9f65c3b58faaed83f488",
//           "locality": "Moosarambagh",
//           "areaName": "New Malakpet",
//           "costForTwo": "₹400 for two",
//           "cuisines": [
//             "Pizzas",
//             "Pastas",
//             "Italian",
//             "Desserts",
//             "Beverages"
//           ],
//           "avgRating": 4.2,
//           "parentId": "3534",
//           "avgRatingString": "4.2",
//           "totalRatingsString": "5K+",
//           "sla": {
//             "deliveryTime": 26,
//             "lastMileTravel": 2.6,
//             "serviceability": "SERVICEABLE",
//             "slaString": "23-29 mins",
//             "lastMileTravelString": "2.6 km",
//             "iconType": "ICON_TYPE_EMPTY"
//           },
//           "availability": {
//             "nextCloseTime": "2024-02-15 23:59:00",
//             "opened": true
//           },
//           "badges": {
            
//           },
//           "isOpen": true,
//           "type": "F",
//           "badgesV2": {
//             "entityBadges": {
//               "imageBased": {
                
//               },
//               "textBased": {
                
//               },
//               "textExtendedBadges": {
                
//               }
//             }
//           },
//           "aggregatedDiscountInfoV3": {
//             "header": "60% OFF",
//             "subHeader": "UPTO ₹110"
//           },
//           "differentiatedUi": {
//             "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             "differentiatedUiMediaDetails": {
//               "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//               "lottie": {
                
//               },
//               "video": {
                
//               }
//             }
//           },
//           "reviewsSummary": {
            
//           },
//           "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           "restaurantOfferPresentationInfo": {
            
//           }
//         },
//         "analytics": {
          
//         },
//         "cta": {
//           "link": "https://www.swiggy.com/restaurants/oven-story-pizza-standout-toppings-moosarambagh-new-malakpet-hyderabad-124590",
//           "type": "WEBLINK"
//         }
//       }



// ]


export const resList= [
  {
    "info": {
      "id": "244004",
      "name": "Wow! Momo",
      "cloudinaryImageId": "5a148e63e9c54942e37627da1aa156be",
      "locality": "5th sector",
      "areaName": "HSR Layout",
      "costForTwo": "₹300 for two",
      "cuisines": [
        "Tibetan",
        "Healthy Food",
        "Asian",
        "Chinese",
        "Snacks",
        "Continental",
        "Desserts",
        "Beverages"
      ],
      "avgRating": 4.2,
      "parentId": "1776",
      "promoted":true,
      "avgRatingString": "4.2",
      "totalRatingsString": "1K+",
      "sla": {
        "deliveryTime": 30,
        "lastMileTravel": 1.5,
        "serviceability": "SERVICEABLE",
        "slaString": "25-30 mins",
        "lastMileTravelString": "1.5 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2024-02-19 03:00:00",
        "opened": true
      },
      "badges": {
        
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            
          },
          "textBased": {
            
          },
          "textExtendedBadges": {
            
          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹99"
      },
      "orderabilityCommunication": {
        "title": {
          
        },
        "subTitle": {
          
        },
        "message": {
          
        },
        "customIcon": {
          
        }
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
          "lottie": {
            
          },
          "video": {
            
          }
        }
      },
      "reviewsSummary": {
        
      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {
        
      }
    },
    "analytics": {
      "context": "seo-data-d614ae01-4d23-4f5b-ace0-a53172466046"
    },
    "cta": {
      "link": "https://www.swiggy.com/restaurants/wow-momo-5th-sector-hsr-layout-bangalore-244004",
      "text": "RESTAURANT_MENU",
      "type": "WEBLINK"
    },
    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
  },
  {
    "info": {
      "id": "712380",
      "name": "Chicago Pizza",
      "cloudinaryImageId": "80f040545552605e33eba09f8fa30be9",
      "locality": "khb colony",
      "areaName": "Koramangala",
      "costForTwo": "₹500 for two",
      "cuisines": [
        "Pizzas",
        "Fast Food",
        "Italian"
      ],
      "avgRating": 4.1,
      "parentId": "60277",
      "avgRatingString": "4.1",
      "totalRatingsString": "100+",
      "promoted":true,
      "sla": {
        "deliveryTime": 40,
        "lastMileTravel": 5,
        "serviceability": "SERVICEABLE",
        "slaString": "40-45 mins",
        "lastMileTravelString": "5.0 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2024-02-19 01:15:00",
        "opened": true
      },
      "badges": {
        
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            
          },
          "textBased": {
            
          },
          "textExtendedBadges": {
            
          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "₹125 OFF",
        "subHeader": "ABOVE ₹499",
        "discountTag": "FLAT DEAL"
      },
      "orderabilityCommunication": {
        "title": {
          
        },
        "subTitle": {
          
        },
        "message": {
          
        },
        "customIcon": {
          
        }
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
          "lottie": {
            
          },
          "video": {
            
          }
        }
      },
      "reviewsSummary": {
        
      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {
        
      }
    },
    "analytics": {
      "context": "seo-data-d614ae01-4d23-4f5b-ace0-a53172466046"
    },
    "cta": {
      "link": "https://www.swiggy.com/restaurants/chicago-pizza-khb-colony-koramangala-bangalore-712380",
      "text": "RESTAURANT_MENU",
      "type": "WEBLINK"
    },
    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
  },
  {
    "info": {
      "id": "654809",
      "name": "Meghana Foods",
      "cloudinaryImageId": "c627e55c996978a070c10079ae57f706",
      "locality": "G R S TOWERS",
      "areaName": "Sarjapur Road",
      "costForTwo": "₹500 for two",
      "cuisines": [
        "Biryani",
        "Andhra",
        "South Indian",
        "Chinese",
        "Seafood"
      ],
      "avgRating": 4.5,
      "parentId": "635",
      "avgRatingString": "4.5",
      "totalRatingsString": "10K+",
      "promoted":true,
      "sla": {
        "deliveryTime": 35,
        "lastMileTravel": 5,
        "serviceability": "SERVICEABLE",
        "slaString": "35-40 mins",
        "lastMileTravelString": "5.0 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2024-02-19 01:30:00",
        "opened": true
      },
      "badges": {
        
      },
      "isOpen": true,
      "aggregatedDiscountInfoV2": {
        
      },
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            
          },
          "textBased": {
            
          },
          "textExtendedBadges": {
            
          }
        }
      },
      "orderabilityCommunication": {
        "title": {
          
        },
        "subTitle": {
          
        },
        "message": {
          
        },
        "customIcon": {
          
        }
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
          "lottie": {
            
          },
          "video": {
            
          }
        }
      },
      "reviewsSummary": {
        
      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {
        
      }
    },
    "analytics": {
      "context": "seo-data-d614ae01-4d23-4f5b-ace0-a53172466046"
    },
    "cta": {
      "link": "https://www.swiggy.com/restaurants/meghana-foods-g-r-s-towers-sarjapur-road-bangalore-654809",
      "text": "RESTAURANT_MENU",
      "type": "WEBLINK"
    },
    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
  },
  {
    "info": {
      "id": "279024",
      "name": "Andhra Gunpowder",
      "cloudinaryImageId": "od1vem08qw94dfzt5ms3",
      "locality": "7th Sector",
      "areaName": "Hsr Layout",
      "costForTwo": "₹350 for two",
      "cuisines": [
        "Andhra",
        "Biryani",
        "South Indian"
      ],
      "avgRating": 4.3,
      "parentId": "10496",
      "avgRatingString": "4.3",
      "totalRatingsString": "5K+",
      "promoted":false,
      "sla": {
        "deliveryTime": 19,
        "lastMileTravel": 1.7,
        "serviceability": "SERVICEABLE",
        "slaString": "15-20 mins",
        "lastMileTravelString": "1.7 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2024-02-18 23:00:00",
        "opened": true
      },
      "badges": {
        "textExtendedBadges": [
          {
            "iconId": "guiltfree/GF_Logo_android_3x",
            "shortDescription": "options available",
            "fontColor": "#7E808C"
          }
        ]
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            
          },
          "textBased": {
            
          },
          "textExtendedBadges": {
            "badgeObject": [
              {
                "attributes": {
                  "description": "",
                  "fontColor": "#7E808C",
                  "iconId": "guiltfree/GF_Logo_android_3x",
                  "shortDescription": "options available"
                }
              }
            ]
          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "₹100 OFF",
        "subHeader": "ABOVE ₹399",
        "discountTag": "FLAT DEAL"
      },
      "orderabilityCommunication": {
        "title": {
          
        },
        "subTitle": {
          
        },
        "message": {
          
        },
        "customIcon": {
          
        }
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
          "lottie": {
            
          },
          "video": {
            
          }
        }
      },
      "reviewsSummary": {
        
      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {
        
      }
    },
    "analytics": {
      "context": "seo-data-d614ae01-4d23-4f5b-ace0-a53172466046"
    },
    "cta": {
      "link": "https://www.swiggy.com/restaurants/andhra-gunpowder-7th-sector-hsr-layout-bangalore-279024",
      "text": "RESTAURANT_MENU",
      "type": "WEBLINK"
    },
    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
  },
  {
    "info": {
      "id": "50467",
      "name": "Bakingo",
      "cloudinaryImageId": "fa68ac0434f668bba1322abda36570b3",
      "locality": "1st Block",
      "areaName": "Koramangala",
      "costForTwo": "₹300 for two",
      "cuisines": [
        "Bakery",
        "Desserts",
        "Beverages",
        "Snacks"
      ],
      "avgRating": 4.3,
      "parentId": "3818",
      "avgRatingString": "4.3",
      "totalRatingsString": "5K+",
      "sla": {
        "deliveryTime": 31,
        "lastMileTravel": 3,
        "serviceability": "SERVICEABLE",
        "slaString": "30-35 mins",
        "lastMileTravelString": "3.0 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2024-02-19 01:00:00",
        "opened": true
      },
      "badges": {
        
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            
          },
          "textBased": {
            
          },
          "textExtendedBadges": {
            
          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "60% OFF",
        "subHeader": "UPTO ₹120"
      },
      "orderabilityCommunication": {
        "title": {
          
        },
        "subTitle": {
          
        },
        "message": {
          
        },
        "customIcon": {
          
        }
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
          "lottie": {
            
          },
          "video": {
            
          }
        }
      },
      "reviewsSummary": {
        
      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {
        
      }
    },
    "analytics": {
      "context": "seo-data-d614ae01-4d23-4f5b-ace0-a53172466046"
    },
    "cta": {
      "link": "https://www.swiggy.com/restaurants/bakingo-1st-block-koramangala-bangalore-50467",
      "text": "RESTAURANT_MENU",
      "type": "WEBLINK"
    },
    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
  },
  {
    "info": {
      "id": "201224",
      "name": "Asha tiffins",
      "cloudinaryImageId": "n15vckntsiboiod3gpco",
      "locality": "HSR Layout",
      "areaName": "Hsr Layout",
      "costForTwo": "₹200 for two",
      "cuisines": [
        "South Indian",
        "North Indian",
        "Chinese",
        "Desserts",
        "Beverages"
      ],
      "avgRating": 4.5,
      "parentId": "236243",
      "avgRatingString": "4.5",
      "totalRatingsString": "10K+",
      "sla": {
        "deliveryTime": 18,
        "lastMileTravel": 1.4,
        "serviceability": "SERVICEABLE",
        "slaString": "15-20 mins",
        "lastMileTravelString": "1.4 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2024-02-18 15:30:00",
        "opened": true
      },
      "badges": {
        "imageBadges": [
          {
            "imageId": "v1695133679/badges/Pure_Veg111.png",
            "description": "pureveg"
          }
        ]
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            "badgeObject": [
              {
                "attributes": {
                  "description": "pureveg",
                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                }
              }
            ]
          },
          "textBased": {
            
          },
          "textExtendedBadges": {
            
          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "50% OFF",
        "subHeader": "UPTO ₹100"
      },
      "orderabilityCommunication": {
        "title": {
          
        },
        "subTitle": {
          
        },
        "message": {
          
        },
        "customIcon": {
          
        }
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
          "lottie": {
            
          },
          "video": {
            
          }
        }
      },
      "reviewsSummary": {
        
      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {
        
      }
    },
    "analytics": {
      "context": "seo-data-d614ae01-4d23-4f5b-ace0-a53172466046"
    },
    "cta": {
      "link": "https://www.swiggy.com/restaurants/asha-tiffins-hsr-layout-bangalore-201224",
      "text": "RESTAURANT_MENU",
      "type": "WEBLINK"
    },
    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
  },
  {
    "info": {
      "id": "171768",
      "name": "Mumbai Tiffin",
      "cloudinaryImageId": "h58dwaoafbqj0ax5h26b",
      "locality": "HSR Layout",
      "areaName": "HSR Layout",
      "costForTwo": "₹400 for two",
      "cuisines": [
        "Home Food",
        "Thalis"
      ],
      "avgRating": 4.6,
      "veg": true,
      "parentId": "13235",
      "avgRatingString": "4.6",
      "totalRatingsString": "10K+",
      "sla": {
        "deliveryTime": 23,
        "lastMileTravel": 1.4,
        "serviceability": "SERVICEABLE",
        "slaString": "20-25 mins",
        "lastMileTravelString": "1.4 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2024-02-18 16:00:00",
        "opened": true
      },
      "badges": {
        
      },
      "isOpen": true,
      "aggregatedDiscountInfoV2": {
        
      },
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            
          },
          "textBased": {
            
          },
          "textExtendedBadges": {
            
          }
        }
      },
      "orderabilityCommunication": {
        "title": {
          
        },
        "subTitle": {
          
        },
        "message": {
          
        },
        "customIcon": {
          
        }
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
          "lottie": {
            
          },
          "video": {
            
          }
        }
      },
      "reviewsSummary": {
        
      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {
        
      }
    },
    "analytics": {
      "context": "seo-data-d614ae01-4d23-4f5b-ace0-a53172466046"
    },
    "cta": {
      "link": "https://www.swiggy.com/restaurants/mumbai-tiffin-hsr-layout-bangalore-171768",
      "text": "RESTAURANT_MENU",
      "type": "WEBLINK"
    },
    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
  },
  {
    "info": {
      "id": "194610",
      "name": "Mani's Dum Biryani",
      "cloudinaryImageId": "j7cijvueivi8qhvnohvw",
      "locality": "HSR Layout\t",
      "areaName": "HSR Layout",
      "costForTwo": "₹300 for two",
      "cuisines": [
        "Andhra",
        "Biryani",
        "North Indian"
      ],
      "avgRating": 4.4,
      "parentId": "623",
      "avgRatingString": "4.4",
      "totalRatingsString": "10K+",
      "sla": {
        "deliveryTime": 29,
        "lastMileTravel": 1.7,
        "serviceability": "SERVICEABLE",
        "slaString": "25-30 mins",
        "lastMileTravelString": "1.7 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2024-02-18 23:45:00",
        "opened": true
      },
      "badges": {
        "textExtendedBadges": [
          {
            "iconId": "guiltfree/GF_Logo_android_3x",
            "shortDescription": "options available",
            "fontColor": "#7E808C"
          }
        ]
      },
      "isOpen": true,
      "aggregatedDiscountInfoV2": {
        
      },
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            
          },
          "textBased": {
            
          },
          "textExtendedBadges": {
            "badgeObject": [
              {
                "attributes": {
                  "description": "",
                  "fontColor": "#7E808C",
                  "iconId": "guiltfree/GF_Logo_android_3x",
                  "shortDescription": "options available"
                }
              }
            ]
          }
        }
      },
      "orderabilityCommunication": {
        "title": {
          
        },
        "subTitle": {
          
        },
        "message": {
          
        },
        "customIcon": {
          
        }
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
          "lottie": {
            
          },
          "video": {
            
          }
        }
      },
      "reviewsSummary": {
        
      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {
        
      }
    },
    "analytics": {
      "context": "seo-data-d614ae01-4d23-4f5b-ace0-a53172466046"
    },
    "cta": {
      "link": "https://www.swiggy.com/restaurants/manis-dum-biryani-hsr-layout-bangalore-194610",
      "text": "RESTAURANT_MENU",
      "type": "WEBLINK"
    },
    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
  },
  {
    "info": {
      "id": "376713",
      "name": "Big Bowl",
      "cloudinaryImageId": "c99751d54e4e1847186c62b3309c1327",
      "locality": "3rd Sector",
      "areaName": "HSR Layout",
      "costForTwo": "₹250 for two",
      "cuisines": [
        "North Indian",
        "Chinese",
        "Tibetan",
        "Desserts"
      ],
      "avgRating": 4,
      "parentId": "434792",
      "avgRatingString": "4.0",
      "totalRatingsString": "1K+",
      "sla": {
        "deliveryTime": 26,
        "lastMileTravel": 1,
        "serviceability": "SERVICEABLE",
        "slaString": "25-30 mins",
        "lastMileTravelString": "1.0 km",
        "iconType": "ICON_TYPE_EMPTY"
      },
      "availability": {
        "nextCloseTime": "2024-02-19 02:00:00",
        "opened": true
      },
      "badges": {
        
      },
      "isOpen": true,
      "type": "F",
      "badgesV2": {
        "entityBadges": {
          "imageBased": {
            
          },
          "textBased": {
            
          },
          "textExtendedBadges": {
            
          }
        }
      },
      "aggregatedDiscountInfoV3": {
        "header": "ITEMS",
        "subHeader": "AT ₹169"
      },
      "orderabilityCommunication": {
        "title": {
          
        },
        "subTitle": {
          
        },
        "message": {
          
        },
        "customIcon": {
          
        }
      },
      "differentiatedUi": {
        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        "differentiatedUiMediaDetails": {
          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
          "lottie": {
            
          },
          "video": {
            
          }
        }
      },
      "reviewsSummary": {
        
      },
      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      "restaurantOfferPresentationInfo": {
        
      }
    },
    "analytics": {
      "context": "seo-data-d614ae01-4d23-4f5b-ace0-a53172466046"
    },
    "cta": {
      "link": "https://www.swiggy.com/restaurants/big-bowl-3rd-sector-hsr-layout-bangalore-376713",
      "text": "RESTAURANT_MENU",
      "type": "WEBLINK"
    },
    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
  }
];

export default resList;